import { buildExternalWebUrl } from '@/utils/publicShareUrls';

const JOURNEY_ENTRY_PATH = /^\/journey\/([a-z0-9][a-z0-9-]{0,99})\/start$/i;

/** Navigation intent only. The entry page and server independently check access. */
export function getDirectJourneyId(path: string): string | null {
  if (!path.startsWith('/') || path.startsWith('//') || path.includes('\\')) return null;
  try {
    const url = new URL(path, 'https://journalparty.com');
    if (url.origin !== 'https://journalparty.com') return null;
    return JOURNEY_ENTRY_PATH.exec(url.pathname)?.[1] ?? null;
  } catch { return null; }
}

/** A session number the entry route may forward to the player (1-365). */
export function parseJourneyEntryDay(value: unknown): number | null {
  const day = typeof value === 'number' ? value : typeof value === 'string' && /^\d{1,3}$/.test(value) ? Number(value) : NaN;
  return Number.isInteger(day) && day >= 1 && day <= 365 ? day : null;
}

export function journeyEntryPath(journeyId: string, options: { day?: number | null } = {}) {
  const path = `/journey/${journeyId}/start`;
  if (!getDirectJourneyId(path)) throw new Error('Invalid Journey destination');
  const day = parseJourneyEntryDay(options.day);
  return day ? `${path}?day=${day}` : path;
}

/** The session (`?day=K`) a direct or nested (`returnTo`) Journey entry path asks for. */
export function getJourneyEntryDay(path: string): number | null {
  try {
    const url = new URL(path || '', 'https://journalparty.com');
    if (getDirectJourneyId(path)) return parseJourneyEntryDay(url.searchParams.get('day'));
    const nested = url.searchParams.get('returnTo');
    return nested && getDirectJourneyId(nested) ? parseJourneyEntryDay(new URL(nested, 'https://journalparty.com').searchParams.get('day')) : null;
  } catch { return null; }
}

export function buildJourneyCheckoutUrls(journeyId: string, provider: 'stripe' | 'paypal', options: { day?: number | null } = {}) {
  // Keep the chosen session through hosted checkout so the member lands on it.
  const destination = journeyEntryPath(journeyId, { day: options.day });
  return {
    successUrl: buildExternalWebUrl('/welcome-premium', {
      checkout: 'success', provider, returnTo: destination,
    }),
    cancelUrl: buildExternalWebUrl(destination, { checkout: 'canceled', provider }),
  };
}
